import appReducer from "./reducers";
export { default as appOperations } from "./operations";

export default appReducer;
